var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "search-date-range" },
    [
      _c("el-date-picker", {
        staticStyle: { width: "100%" },
        attrs: {
          type: "daterange",
          "range-separator": "-",
          "start-placeholder": "年/月/日",
          "end-placeholder": "年/月/日",
          "value-format": "yyyy-MM-dd HH:mm:ss",
          format: "yyyy/MM/dd",
          "default-time": ["00:00:00", "23:59:59"],
          "picker-options": _vm.pickerOptions,
          clearable: "",
          "prefix-icon": "el-icon-date",
        },
        on: { change: _vm.onChangeDate },
        model: {
          value: _vm.date,
          callback: function ($$v) {
            _vm.date = $$v
          },
          expression: "date",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }